import { createSlice } from "@reduxjs/toolkit";
import {
  getAllActiveBanner,
  getAllActiveSettings,
  getAllActiveTestimonials,
  getAllMetaData,
  getHomeDetails,
} from "@/services/home.services";

interface HomeState {
  loading: boolean;
  bannerLoading: boolean;
  settingLoading: boolean;
  seoLoading: boolean;
  testimonialLoading: boolean;
  homeLoading: boolean;
  error: string;
  homeDetails: Record<string, any>;
  MetaDetails: {
    MetaTitle: string;
    MetaKeywords: string;
    MetaDescription: string;
  };
  SettingList: any[];
  TestominalList: any[];
  BannerList: any[];
}

export interface ICMS {
  ID: number | null;
  Name: string;
  CMSURL: string;
  CMSImage: string;
  CMSImageAlterTag?: string;
  Template: string;
  MetaTitle: string;
  MetaKeyword: string;
  MetaDescription: string;
  cms_image_details: any[];
}

export interface ISettings {
  ID: number | null;
  SettingKey: string;
  SettingType: string;
  SettingValue: string;
  addressmap: string;
}

const initialState: HomeState = {
  loading: false,
  bannerLoading: false,
  settingLoading: false,
  seoLoading: false,
  testimonialLoading: false,
  homeLoading: false,
  error: "",
  homeDetails: {},
  MetaDetails: {
    MetaTitle: "",
    MetaKeywords: "",
    MetaDescription: "",
  },
  SettingList: [],
  TestominalList: [],
  BannerList: [],
};

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getHomeDetails.pending, (state) => {
      state.homeLoading = true;
    });
    builder.addCase(getHomeDetails.fulfilled, (state, action) => {
      state.homeLoading = false;
      state.homeDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getHomeDetails.rejected, (state, action) => {
      state.homeLoading = false;
      state.homeDetails = initialState.homeDetails;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllActiveSettings.pending, (state) => {
      state.settingLoading = true;
    });
    builder.addCase(getAllActiveSettings.fulfilled, (state, action) => {
      state.settingLoading = false;
      state.SettingList = action.payload;
      state.error = "";
    });
    builder.addCase(getAllActiveSettings.rejected, (state, action) => {
      state.settingLoading = false;
      state.SettingList = initialState.SettingList;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllMetaData.pending, (state) => {
      state.seoLoading = true;
    });
    builder.addCase(getAllMetaData.fulfilled, (state, action) => {
      state.seoLoading = false;
      state.MetaDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getAllMetaData.rejected, (state, action) => {
      state.seoLoading = false;
      state.MetaDetails = initialState.MetaDetails;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllActiveTestimonials.pending, (state) => {
      state.testimonialLoading = true;
    });
    builder.addCase(getAllActiveTestimonials.fulfilled, (state, action) => {
      state.testimonialLoading = false;
      state.TestominalList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllActiveTestimonials.rejected, (state, action) => {
      state.testimonialLoading = false;
      state.TestominalList = [];
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllActiveBanner.pending, (state) => {
      state.bannerLoading = true;
    });
    builder.addCase(getAllActiveBanner.fulfilled, (state, action) => {
      state.bannerLoading = false;
      state.BannerList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllActiveBanner.rejected, (state, action) => {
      state.bannerLoading = false;
      state.BannerList = [];
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default homeSlice.reducer;
